import { useEffect } from 'react';
import { usePostHog } from '../hooks/usePostHog';

/**
 * PostHog Helper Component
 * 
 * Stores PostHog instance globally so it can be accessed from non-React code (e.g., Redux sagas)
 * This component should be rendered once at the app root level.
 */
export function PostHogHelper() {
  const posthog = usePostHog();

  useEffect(() => {
    if (posthog) {
      // Store PostHog instance globally for use in sagas and other non-React code
      (global as any).posthog = posthog;
      if (typeof window !== 'undefined') {
        (window as any).posthog = posthog;
      }
      console.log('✅ [POSTHOG] PostHog instance stored globally', {
        hasCapture: typeof posthog.capture === 'function',
        hasIdentify: typeof posthog.identify === 'function',
      });
    } else {
      console.warn('⚠️ [POSTHOG] PostHog instance is null, not storing globally');
    }

    return () => {
      // Cleanup on unmount
      delete (global as any).posthog;
      if (typeof window !== 'undefined') {
        delete (window as any).posthog;
      }
    };
  }, [posthog]);

  // This component doesn't render anything
  return null;
}


